import React, { useEffect, useState, useRef, useCallback } from "react";
import { themeIcons } from "config/theme";
import VIcon from "components/custom/Icon";
import { map, debounce, find, filter, upperCase, get, forEach, isEmpty, set } from "lodash";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
import {
    ApiKey,
    ApiUrl,
    WebUrl,
    SessionKey,
    AlertTypes,
    _MAIN_WALLET_ID,
    //PhoneNumberPrefix,
    DEFAULT_REFERRAL_CODE,
} from "../../util/Constant";
import {
    Alert,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Modal,
    ModalHeader,
    ModalBody,
    Spinner,
    UncontrolledDropdown,
} from "reactstrap";
import ApiEngine from "../../util/ApiEngine.js";
import { createMultiPartFormBody } from "../../util/Util";
import i18n from "localization/i18n";
import { saveLanguageId } from "redux/LanguageAction";
import {
    setLanguageModal
} from "../../redux/AppAction.js";

const LanguageSelection = (props) => {
    const { 
        type, //types: dropdownUI, modalUI
        showLabelText, 
        className,
        arrow,
        showModalButton
    } = props;

    var { t } = useTranslation();
    var _history = useHistory();
    var _dispatch = useDispatch();
    const location = useLocation();

    var { heartBeat } = useSelector((state) => state.authState);
    const languageModal = useSelector((state)=>state.appState.languageModal)
    var companyLanguages = useSelector((state) => state.appState.languages);
    const [languageSelected, setLanguageSelected] = useState(
        companyLanguages.find(
            (x) => x.code == localStorage.getItem(SessionKey._LANGUAGE)
        )
    );
    const memberData = useSelector((state) => state.appState.member);
    const [dropdownOpen, setDropdownOpen] = useState(false);

    useEffect(() => {
        // Set default language
        if (companyLanguages?.length) {
            const tempLangCode = companyLanguages[0]?.code;
            const storedLanguage = localStorage.getItem(SessionKey._LANGUAGE);
            const tempLang = companyLanguages.find((x) => x.isDefault === true);
            if (storedLanguage && storedLanguage !== "undefined") {
                onInitLanguage(storedLanguage);
            } else if (tempLang) {
                onInitLanguage(tempLang.code);
            } else {
                onInitLanguage(tempLangCode);
            }
        }

        // Hierarchy: account lang > user selected lang > ip lang > browser lang > default

        const currentDate = new Date();
        const oneDayInMilliseconds = 24 * 60 * 60 * 1000;
        const localeUserCreatedDate = new Date(
            localStorage.getItem("userSelectedLanguageCodeCreatedAt") || 0
        );
        const localeIpCreatedDate = new Date(
            localStorage.getItem("ipCreatedAt") || 0
        );

        if (
            heartBeat &&
            Object.keys(memberData).length > 0 &&
            companyLanguages != undefined &&
            currentDate - localeUserCreatedDate > oneDayInMilliseconds
        ) {
            const language = companyLanguages.find(
                (x) => x.id == memberData.languageSetting
            );
            if(language) {
                if(language==null){language.code='en'}
                localStorage.setItem("userSelectedLanguageCode", language.code);
                localStorage.setItem("userSelectedLanguageCodeCreatedAt", new Date());
                //console.log('Set lang by member')
                onInitLanguage(language.code);
            }
        } else {
            if (
                localStorage.getItem("userSelectedLanguageCode") &&
                currentDate - localeUserCreatedDate <= oneDayInMilliseconds
            ) {
                //console.log('Set lang by guest user')
                onInitLanguage(localStorage.getItem("userSelectedLanguageCode"));
            } else {
                if (
                    !localStorage.getItem("ipLanguageCode") ||
                    currentDate - localeIpCreatedDate > oneDayInMilliseconds
                ) {
                    // Disabled by Chris 20241009 - calling too many times and also causing CORS errors, remove for now
                    // setLanguageByIPLocaleOrBrowserLocale();
                }
            }
        }
    }, [
        companyLanguages,
        memberData,
        heartBeat,
        languageSelected,
        localStorage.getItem(SessionKey._LANGUAGE)
    ]);


    const toggleDropDown = () => setDropdownOpen((prevState) => !prevState);

    const onInitLanguage = (value) => {
        // console.log("onInitLanguage", value);
        let findLanguage = find(companyLanguages, { code: value });
        onChangeLanguage(findLanguage);
    };

    const onClickLanguage = async (value) => {
        let findLanguage = find(companyLanguages, { code: value });
        onChangeLanguage(findLanguage);

        localStorage.setItem("userSelectedLanguageCode", findLanguage.code);
        localStorage.setItem("userSelectedLanguageCodeCreatedAt", new Date());

        if (heartBeat) {
            let data = {};
            data["languageSetting"] = findLanguage.code;

            await ApiEngine.post(
                ApiUrl._API_UPDATE_MEMBER_LANGUAGE,
                createMultiPartFormBody(data)
            );

            // KT: Why we call this? After change language we need to bindMember for language?
            // bindMember(_dispatch);
        }
    };

    const onChangeLanguage = async (selectedLanguage) => {
        setLanguageSelected(selectedLanguage);

        const previousLocale = localStorage.getItem(SessionKey._LANGUAGE);
        if (selectedLanguage) {
            // Update the body data-locale attribute
            document.body.setAttribute("data-locale", selectedLanguage.code);

            i18n.changeLanguage(selectedLanguage.code);
            _dispatch(saveLanguageId(selectedLanguage.code, true));

            // CHRIS_LOCALE: Update the URL to reflect the new language
            if (previousLocale !== selectedLanguage.code) {
                let locationPathname = location.pathname;

                // Use the regex to replace the locale at the start of the pathname
                if (locationPathname.startsWith(`/${previousLocale}`)) {
                    const regex = new RegExp(`^/${previousLocale}(/|$)`);
                    locationPathname = location.pathname.replace(
                        regex,
                        `/${selectedLanguage.code}/`
                    );
                }
                // Ensure that the URL does not end with a slash, unless it's just the root "/"
                locationPathname =
                    locationPathname === `/${selectedLanguage.code}/`
                        ? `/${selectedLanguage.code}`
                        : locationPathname;

                locationPathname += location.search;

                _history.replace(locationPathname);

                // CHRIS_LOCALE: Update the current locale in WebUrl
                // console.log("WebUrl.setCurrentLocale", selectedLanguage.code);
                WebUrl.setCurrentLocale(selectedLanguage.code);

                // Create a custom event
                const customEvent = new CustomEvent("changedLocale", {
                    detail: { message: "Changed locale!" },
                });

                // Dispatch the event
                window.dispatchEvent(customEvent);
            }
        }
    };

    return (
        <>
            {companyLanguages && companyLanguages.length > 1 && type == "dropdownUI" && (
                <UncontrolledDropdown
                    className={"drop-down-language " + (className ? className : "")} 
                    isOpen={dropdownOpen}
                    toggle={toggleDropDown}
                    direction="down"
                >
                    <DropdownToggle>
                        {" "}
                        {languageSelected && languageSelected?.icon ? (
                            <img
                                src={languageSelected?.icon}
                                className="img-responsive language-flag"
                                alt="profile"
                            />
                        ) : (
                            <img
                                src={require("../../assets/img/template_1/default_lang.png")}
                                className="img-responsive language-flag"
                                alt="profile"
                            />
                        )}
                        {showLabelText && languageSelected && languageSelected?.name && (
                            <div className="ml-1">
                                {languageSelected?.name}
                            </div>
                        )}
                        {arrow != false && (
                            <svg
                                focusable="false"
                                color="#ffffff"
                                aria-hidden="true"
                                viewBox="0 0 24 24"
                                data-testid="ExpandMoreIcon"
                                fill="white"
                                height="20px"
                                className="language-arrow-down"
                            >
                                <path d="M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"></path>
                            </svg>
                        )}
                        
                    </DropdownToggle>
                    <DropdownMenu end={"true"} className="language-dropdown-menu">
                        {companyLanguages &&
                            companyLanguages.length > 0 &&
                            map(companyLanguages, (item, index) => {
                                return (
                                    <DropdownItem
                                        key={index}
                                        onClick={() => onClickLanguage(item.code)}
                                    >
                                        {item.icon ? (
                                            <img src={item.icon} alt="flag" height="20px" />
                                        ) : (
                                            <img
                                                src={require("../../assets/img/template_1/default_lang.png")}
                                                className="img-responsive"
                                                alt="profile"
                                                width="20px"
                                            />
                                        )}{" "}
                                        <span className="ml-1">{item.name}</span>
                                    </DropdownItem>
                                );
                            })}
                    </DropdownMenu>
                </UncontrolledDropdown>
            )}
            {companyLanguages && companyLanguages.length > 1 && type == "modalUI" && (
              <>
                {showModalButton && (
                    <button
                     className="language-modal-default-button btn"
                     onClick={() => {
                        _dispatch(setLanguageModal(true));
                     }}
                    >
                        {languageSelected && languageSelected?.icon ? (
                            <img
                                src={languageSelected?.icon}
                                className="img-responsive language-flag"
                                alt="profile"
                            />
                        ) : (
                            <img
                                src={require("../../assets/img/template_1/default_lang.png")}
                                className="img-responsive language-flag"
                                alt="profile"
                            />
                        )}
                        {showLabelText && languageSelected && languageSelected?.name && (
                            <div className="ml-1">
                                {languageSelected?.name}
                            </div>
                        )}
                        {arrow != false && (
                            <svg
                                focusable="false"
                                color="#ffffff"
                                aria-hidden="true"
                                viewBox="0 0 24 24"
                                data-testid="ExpandMoreIcon"
                                fill="white"
                                height="20px"
                                className="language-arrow-down"
                            >
                                <path d="M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"></path>
                            </svg>
                        )}
                    </button>
                )}
                <Modal
                    id="t3-custom-modal"
                    className="modal-custom-fullscreen"
                    contentClassName={
                        "t3-custom-modal t3-custom-modal-with-back-btn min-height-600px"
                    }
                    fade={false}
                    isOpen={languageModal}
                    toggle={() => {
                        _dispatch(setLanguageModal(false));
                    }}
                >
                    <ModalHeader>
                        <div className="first">{t("CHANGE_LANGUAGE")}</div>
                        <div className="second">
                            <div
                                className="t3-close-custom-modal"
                                onClick={() => {
                                    _dispatch(setLanguageModal(false));
                                }}
                            >
                                <VIcon icon={themeIcons.close} className="vicon" />
                            </div>
                        </div>
                    </ModalHeader>
                    <ModalBody>
                        <div className="t3-custom-modal-container">
                            <div className="custom-body">
                                <div className="t3-settings-menu-list mt-3">
                                    {companyLanguages &&
                                        companyLanguages.length > 0 &&
                                        companyLanguages.map((lang, index) => {
                                            return (
                                                <div
                                                    key={index}
                                                    onClick={() => {
                                                        _dispatch(setLanguageModal(false));
                                                        // onChangeLanguage(lang.code);
                                                        onClickLanguage(lang.code);
                                                    }}
                                                    style={{ cursor: "pointer" }}
                                                    className={"t3-settings-menu-list-item " + (lang.code == languageSelected?.code ? "active" : "")}
                                                >
                                                    <div className="first">
                                                    {lang.icon ? (
                                                         <img src={lang.icon} alt="flag" className="language-flag" />
                                                     ) : (
                                                         <img
                                                             src={require("../../assets/img/template_1/default_lang.png")}
                                                             className="language-flag"
                                                             alt="default-flag"
                                                         />
                                                     )}
                                                        <div className="font14 f-weight-700">{lang.name}</div>
                                                    </div>
                                                    <div className="second">
                                                        <div style={{ cursor: "pointer" }}>{lang.code == languageSelected?.code ? t("SELECTED") : t("SELECT")}</div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
              </>
            )}
        </>
    );
};

export default LanguageSelection;
